import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-campaigns-available-templates',
  templateUrl: './available-templates.component.html',
  styleUrls: ['./available-templates.component.css']
})
export class AvailableTemplatesComponent implements OnInit {

  @ViewChild('modalShow') modalShow;
  @ViewChild('modalHide') modalHide;
  public userData;

  public filteredData = [];
  public editEmailObj={};
  public templateForm:FormGroup;
  public searchForm:FormGroup;
  public name=this.fb.control('',[Validators.required]);
  public email=this.fb.control('',[Validators.required,Validators.email]);
  public modalTitle;
  public modalType;
  public uniqueID;
  public filterEnable:boolean=false;
  public page:number = 1;
  public templateFilterEnable:boolean = false;
  public templateData = [
    { 
      orgID: "60866279d774d4408635033b",
      templateID:"1",
      title:'Route Delayed / Advanced_NoAlert', 
      message:'The Routes Are {Delayed/Advanced} By {Mm} Mins. Hence The Proximity Alerts Will Be {Delayed /Advanced} Accordingly.'
    },
    { 
      orgID: "60866279d774d4408635033b",
      templateID:"2",
      title:'Resuming Alert Services', 
      message:'Dear Manager, This Is From Group10! We Shall Be Resuming The Proximity Call/SMS Alert Services From Monday, 27th Sep. Thank You For Your Support.'
    },
    { 
      orgID: "60866279d774d4408635033b",
      templateID:"3",
      title:'Alert Services Suspended', 
      message:'Dear Manager, This Is From Group10! The Call/SMS Alert Services Will Be Suspended For The Next Two Days As Our Service Provider Is Upgrading Their Infrastructure In Order To Address Few Reported Issues Of Delayed Alerts. However, Manager Can Continue To Receive Notifications And Track The Vehicle On The Mobile App. Manager May Receive Alerts From The Existing Number, Or From A New Number After Upgrading The System. We Will Keep You Informed. Inconvenience Regretted.'
    },
    { 
      orgID: "60866279d774d4408635033b",
      templateID:"4",
      title:'Test Template', 
      message:'The Routes Are {Delayed/Advanced} By {Mm} Mins. Please Keep Track Of Vehicle And Time From The AttendantThis Is A Dummy Template Added For Testing.'
    },
    { 
      orgID: "60866279d774d4408635033b",
      templateID:"5",
      title:'Test', 
      message:'Test Available Template',
    },
  ];

  public templateTableData = [];
  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder) { 
      this.userData = this.storage.get('userInfo')
  }

  ngOnInit(): void {
    this.addTemplateForm();
    this.searchFormLoad();
    this.getTemplateData();
    //this.templateTableData = [ ...this.templateData];
  }

  /* get template data*/
  getTemplateData() {
    const obj = {
      orgID: this.userData.orgID,
    };
    this.api.transportManagerCampaignTemplateList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.templateData = res.data;
        this.templateTableData = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  // adding controls to form 
  addTemplateForm(){
    this.templateForm=this.fb.group({
      title:this.fb.control('',[Validators.required]),
      message:this.fb.control('',[Validators.required]),
    });
  }

  // search data 
  searchFormLoad(){
    this.searchForm=this.fb.group({
     title:[''],
     message:[''],
    })
  }

  // get search input then filter the table
  fieldChange(){
    this.filteredData = [ ...this.templateData];
    this.templateTableData = [ ...this.templateData];
    // console.log(this.searchForm.value);
    Object.entries(this.searchForm.value).forEach(([key, value]) => {
      if (value)  this.filterTemplate(key,value);  });
  }

  filterTemplate(key,value){
    this.filteredData = this.filteredData.filter((e)=>{
      let keyValue = e[key].toLowerCase();
      if(keyValue.search(value.toLowerCase()) !=-1 )  return e;   
      });

    this.templateTableData = [ ...this.filteredData];
  }

  // Reset filter values
  resetFilter(){
    this.templateTableData = [ ...this.templateData];
  }

  // setup modal config
  templateModal(modalType){
    if(modalType=='add'){
      /* this.formReset(); */
      this.modalTitle='Add Template';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }
    if(modalType=='edit'){
      this.modalTitle='Edit Template';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }

  }

  // closing modal 
  modalClose(){
    this.modalHide.nativeElement.click();
    this.modalTitle='';
    this.modalType='';
    this.uniqueID=undefined;
    this.formReset();
  }  
  
  formReset(){
    this.templateForm.reset();
    // console.log('template Form',this.templateForm);
  }

  // submit form values
  addFormValues(){
    if(this.templateForm.valid){
      this.createTemplate();
      this.modalClose();
      // console.log(this.templateForm);
    }
  }
  
  // api call for create template
  createTemplate(){
    let obj={
      orgID:this.userData.orgID,
      ...this.templateForm.value,
    };
    this.api.transportManagerCampaignTemplateCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getTemplateData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });

  }
  
  // edit template values
  editTemplateData(element){
    this.uniqueID=element.templateID;
    this.patchTemplateData(element)
    this.templateModal('edit');
  }
  patchTemplateData(element){
    let obj={title:element.title,message:element.message};
    this.templateForm.patchValue(obj);
    this.editEmailObj=obj;
  }

  // update template Data
  updateFormValues(){
    if(this.templateForm.valid){
      let updateObj={};
      let key=Object.keys(this.templateForm.value);
  
      key.filter((item)=>{
        if(this.editEmailObj[item]!=this.templateForm.value[item]){
          updateObj[item]=this.templateForm.value[item];
        }
      })
  
      if (Object.keys(updateObj).length>0) this.updateTemplate(updateObj);
  
      this.modalClose();
    }
  }

  // update template values
  updateTemplate(updateValues){
    let obj={
      orgID:this.userData.orgID,
      templateID:this.uniqueID,
      ...updateValues
    }
    // console.log(obj);
    this.api.transportManagerCampaignTemplateUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getTemplateData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log('delete click');
        this.deleteTemplate(id);
/*         Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  deleteTemplate(id){
    let obj={
      orgID: this.userData.orgID,
      templateID:id,
    }
    this.api.transportManagerCampaignTemplateDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getTemplateData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });

  }

}
